<template>
  <Box>
    <form class="dialog" onsubmit="return false">
      <div class="header has-bcc-background has-text-white">
        <span>Session expiring soon</span>
        <div>
          <span>{{ secondsLeft }}</span>
          <i class="fa fa-clock-o" />
        </div>
      </div>

      <div class="body">As a security precaution, if there is no additional activity, your session will end and you will be brought to the login page.</div>

      <div class="footer">
        <button class="button" style="margin-right: 10px" @click="closeDialog(null)">Logout</button>
        <button class="button has-bcc-background has-text-white" type="submit" @click="closeDialog(true)" :disabled="!valid">Continue</button>
      </div>
    </form>
  </Box>
</template>

<script setup>
import { onMounted, onUnmounted } from 'vue'
import Box from './Box.vue'
import { closeDialog } from 'vue3-promise-dialog'
import { ref } from 'vue'

const props = defineProps({
  seconds: {
    type: Number,
    default: 30,
  },
  valid: {
    type: Boolean,
    default: true,
  },
  okLabel: {
    type: String,
    default: 'OK',
  },
  cancelLabel: {
    type: String,
    default: 'CANCEL',
  },
})

const secondsLeft = ref(props.seconds)
let countdownInterval

onMounted(() => {
  countdownInterval = setInterval(() => {
    secondsLeft.value = secondsLeft.value - 1
    if (secondsLeft.value <= 0) {
      clearInterval(countdownInterval)
      closeDialog(null)
    }
  }, 1000)
})

onUnmounted(() => {
  clearInterval(countdownInterval)
})
</script>

<style scoped lang="scss">
@import './dialog.scss';
</style>
